(function (window, angular) {
    "use strict";
    var m = angular.module("vvCommon");

    m.controller('PrivacyPolicyCtrl', function ($scope, $rootScope, vv, vvCommon, vvRegister) {
        $scope.region = vv.getVvMetaData('region');

        $scope.deregister = function () {
            vvRegister.deregister();
        }
    });
})(window, window.angular);